"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const ModalSize_1 = require("../../DesignSystem/tokens/global/ModalSize");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const DialogBody_1 = require("./DialogBody");
const DialogFooter_1 = require("./DialogFooter");
const DialogHeader_1 = require("./DialogHeader");
const dialogPaddingHorizontal = new DesignToken_1.default({
    name: 'dialog-paddingHorizontal',
    parent: [Global_1.globalTokens.spacingL, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const dialogHeaderPaddingLeft = new DesignToken_1.default({
    name: 'dialog-header-paddingLeft',
    parent: [Global_1.globalTokens.spacingL, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const dialogHeaderPaddingRight = new DesignToken_1.default({
    name: 'dialog-header-paddingRight',
    parent: [Global_1.globalTokens.spacingL, Global_1.globalTokens.oldTokens.sizeSpaceXL]
});
const dialogBackgroundColor = new DesignToken_1.default({
    name: 'dialog-backgroundColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultSecondary,
        Global_1.globalTokens.oldTokens.colorBackgroundBlank
    ]
});
const dialogBoxShadow = new DesignToken_1.default({
    name: 'dialog-boxShadow',
    parent: [Global_1.globalTokens.boxShadowS, Global_1.globalTokens.oldTokens.boxShadowS]
});
const dialogBorderRadius = new DesignToken_1.default({
    name: 'dialog-borderRadius',
    parent: [Global_1.globalTokens.borderRadiusL, Global_1.globalTokens.oldTokens.borderRadiusNone]
});
const dialogBorderWidth = new DesignToken_1.default({
    name: 'dialog-borderWidth',
    parent: [Global_1.globalTokens.borderWidthNone, Global_1.globalTokens.oldTokens.borderWidthS]
});
const dialogBorderColor = new DesignToken_1.default({
    name: 'dialog-borderColor',
    parent: Global_1.globalTokens.oldTokens.colorWindowBorder
});
// Width
const dialogSizeXXSWidth = new DesignToken_1.default({
    name: 'dialog-size-xxs-width',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeXSWidth = new DesignToken_1.default({
    name: 'dialog-size-xs-width',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeSWidth = new DesignToken_1.default({
    name: 'dialog-size-s-width',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeMWidth = new DesignToken_1.default({
    name: 'dialog-size-m-width',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeLWidth = new DesignToken_1.default({
    name: 'dialog-size-l-width',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeXLWidth = new DesignToken_1.default({
    name: 'dialog-size-xl-width',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeXXLWidth = new DesignToken_1.default({
    name: 'dialog-size-xxl-width',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
// Height
const dialogSizeXXSHeight = new DesignToken_1.default({
    name: 'dialog-size-xxs-height',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeXSHeight = new DesignToken_1.default({
    name: 'dialog-size-xs-height',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeSHeight = new DesignToken_1.default({
    name: 'dialog-size-s-height',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeMHeight = new DesignToken_1.default({
    name: 'dialog-size-m-height',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeLHeight = new DesignToken_1.default({
    name: 'dialog-size-l-height',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeXLHeight = new DesignToken_1.default({
    name: 'dialog-size-xl-height',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
const dialogSizeXXLHeight = new DesignToken_1.default({
    name: 'dialog-size-xxl-height',
    parent: ModalSize_1.modalSizeTokens.modalSizeDefault
});
// DialogActionButton
const dialogActionButtonMinWidth = new DesignToken_1.default({
    name: 'dialog-actionButton-minWidth',
    parent: [Global_1.globalTokens.fieldSizeNone, Global_1.globalTokens.oldTokens.sizeFieldXXS]
});
exports.dialogTokens = Object.assign(Object.assign(Object.assign({ dialogPaddingHorizontal,
    dialogHeaderPaddingLeft,
    dialogHeaderPaddingRight,
    dialogBackgroundColor,
    dialogBoxShadow,
    dialogBorderWidth,
    dialogBorderColor,
    dialogBorderRadius,
    dialogSizeXXSWidth,
    dialogSizeXSWidth,
    dialogSizeSWidth,
    dialogSizeMWidth,
    dialogSizeLWidth,
    dialogSizeXLWidth,
    dialogSizeXXLWidth,
    dialogSizeXXSHeight,
    dialogSizeXSHeight,
    dialogSizeSHeight,
    dialogSizeMHeight,
    dialogSizeLHeight,
    dialogSizeXLHeight,
    dialogSizeXXLHeight,
    dialogActionButtonMinWidth }, DialogHeader_1.dialogHeaderTokens), DialogFooter_1.dialogFooterTokens), DialogBody_1.dialogBodyTokens);
//# sourceMappingURL=Dialog.js.map